import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-course-enrollment-status',
    templateUrl: './course-enrollment-status.component.html',
    styleUrls: ['./course-enrollment-status.component.scss'],
    standalone: false
})

export class CourseEnrollmentStatusComponent implements OnInit, OnChanges {
  @Input() course: any = {};
  translations: any;
  displayStatus: string = '';

  private readonly statusTranslationKeys: Record<string, string> = {
    'NotStarted': 'notStartedText',
    'InProgress': 'inProgressText',
    'Completed': 'completedText',
    'Favourite': 'favouriteText',
    'Retired': 'retiredText',
  };

  constructor(private translationService: TranslationService) {}

  ngOnInit(): void {
    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
        this.updateDisplayStatus();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      const statusKey = (this.course.enrollmentStatus || '').replace(/\s+/g, '');
      this.course.enrollmentClass = "course-enrollment-status left mr-5 " + statusKey;
      this.updateDisplayStatus();
    }
  }

  private updateDisplayStatus(): void {
    const statusKey = (this.course?.enrollmentStatus || '').replace(/\s+/g, '');
    const translationKey = this.statusTranslationKeys[statusKey];
    this.displayStatus = (translationKey && this.translations?.[translationKey])
      || this.course?.enrollmentStatus
      || '';
  }
}
